
import React from 'react';

const Loader = ({ loading, height, styles }) => {

  return loading ? <>
    <style>
      {`
        .loader {
          border: ${height ? height / 6 : 16}px solid #f3f3f3;
          border-radius: 50%;
          border-top: ${height ? height / 6 : 16}px solid #3498db;
          width: 120px;
          height: 120px;
          -webkit-animation: spin 2s linear infinite; /* Safari */
          animation: spin 2s linear infinite;
        }

        /* Safari */
        @-webkit-keyframes spin {
          0% { -webkit-transform: rotate(0deg); }
          100% { -webkit-transform: rotate(360deg); }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}
    </style>
    <span style={height ? { height: height, width: height} : {}} className="loader"></span>
  </> : null;
};

export default Loader;